var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAccountIcon = function SvgAccountIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FB3C6C",
    fillRule: "evenodd",
    d: "M17.761 15.792a16.812 16.812 0 0 0-2.92-1.326 4.945 4.945 0 0 1-2.841.907 4.945 4.945 0 0 1-2.84-.907c-1.173.408-2.14.873-2.921 1.326-1.54.892-2.509 2.607-2.509 4.484V22a.73.73 0 1 1-1.46 0v-1.724c0-2.371 1.224-4.58 3.236-5.747.69-.4 1.504-.804 2.452-1.175C6.883 12.052 6.24 10.25 6.24 8.32 6.24 4.593 8.671 1.27 12 1.27c3.33 0 5.762 3.323 5.762 7.051 0 1.928-.644 3.731-1.72 5.032a17.85 17.85 0 0 1 2.453 1.176c2.012 1.166 3.236 3.376 3.236 5.747V22a.73.73 0 0 1-1.46 0v-1.724c0-1.877-.97-3.592-2.509-4.484ZM12 2.73c-2.23 0-4.3 2.34-4.3 5.591 0 3.252 2.07 5.592 4.3 5.592s4.3-2.34 4.3-5.592c0-3.25-2.07-5.591-4.3-5.591Z",
    clipRule: "evenodd"
  })));
};
export default SvgAccountIcon;